module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-screen2@2x-9899477dee1a6517caec11d0bea64034.png";